module.exports = new __parcel__URL__("publish-a.78969d2d.png").toString();